import AllUsersReport from "../../../components/Reports/AllUsersReport";

const AllUsersReportPage = () => {
  return <AllUsersReport />;
};

export default AllUsersReportPage;
